import { centerable, uploadable } from '../decorators';
import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const audioFileSpec = centerable(uploadable({
  inline: false,
  draggable: true,
  attrs: {
    type: {
      default: 'audioFile'
    },
    url: {
      default: ''
    }
  },
  group: 'block',
  parseDOM: [{
    tag: `.intercom-interblocks-audio-file`,
    getAttrs(dom) {
      let anchor = dom.querySelector('audio');
      return {
        url: anchor.getAttribute('src')
      };
    }
  }, {
    tag: '.embercom-prosemirror-composer-block-container.embercom-prosemirror-composer-audio audio',
    getAttrs(dom) {
      let source = dom.querySelector('source');
      return {
        url: source.getAttribute('src')
      };
    }
  }],
  toDOM(node) {
    return ['div', {
      class: `${BLOCK_CLASSES.blockContainer} ${BLOCK_CLASSES.audio}`
    }, ['audio', {
      class: 'block-audio-file-player',
      controls: '',
      // eslint-disable-next-line @intercom/intercom/no-bare-strings
      controlsList: 'nodownload nofullscreen noremoteplayback noplaybackrate',
      src: node.attrs.url,
      style: `width: 100%;`
    }]];
  }
}));